const Sales = () => import("./Sales.vue");
import Layout from "../../Internal/Layout.vue";

const SalesRoutes = {
  component: Layout,
  children: [
    {
      path: "",
      name: "Sales",
      component: Sales,
      meta: {
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
        requiresAuth: true,
        requiresManagerial: true,
        requiresFinancial: true,
      },
    },
  ],
};

export default SalesRoutes;
